<template>
    <div>
        <common-dialog
            ref="dialog"
            :in-dialog="inDialog"
            width="300px"
            title="商品数量"
            
        >
            <template slot="form">
               <el-form-item label="商品数量" prop="num">
                    <el-input v-model="data.num" placeholder="请输入商品数量" type="number"></el-input>
                </el-form-item>
            </template>
            <template slot="footer">
                 <el-button size="mini" type="primary" @click="saved" >保存</el-button>
                    <el-button size="mini" @click="close">关 闭</el-button>
            </template>
        </common-dialog>
    </div>
</template>



<script>
import commonDialog from "@/components/common/dialog";
import dialog from "@/mixins/dialog";
export default {
 mixins: [dialog],
    components: {
        commonDialog
    },
    data(){
      return {
        data: {
            num: '',
        }
      }
    },
    methods: {
        saved(){
            this.$emit('save', this.data.num)
            this.data.num = '';
        }
    }
}
</script>

